<template>
  <div class="crm-dashboard">
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>账户统计</span>
      </div>
      <el-row :gutter="40">
        <el-col :xs="24" :md="12" :lg="8">
          <div @click="toCustomer">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.customerCount}}</div>
                <div class="label">已开通账户</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8">
          <div @click="toContact">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.contactCount}}<i style="color:#567722" class="el-icon-bottom" /></div>
                <div class="label">今日新增</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8">
          <div @click="toCLue">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.clueCount}}<i style="color:#C72A28" class="el-icon-top" /></div>
                <div class="label">本周新增</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :xs="24" :md="12" :lg="8">
          <div @click="toCustomer">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.customerCount}}</div>
                <div class="label">累计收费(元)</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8">
          <div @click="toContact">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.contactCount}}</div>
                <div class="label">今日新增(元)</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8">
          <div @click="toCLue">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.clueCount}}</div>
                <div class="label">本周新增(元)</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>到期统计</span>
      </div>
      <el-row :gutter="10">
        <el-col :xs="24" :md="12" :lg="6">
          <div @click="toCustomer">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.customerCount}}</div>
                <div class="label">3天内到期</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <div @click="toContact">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.contactCount}}</div>
                <div class="label">7天内到期</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <div @click="toCLue">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.clueCount}}</div>
                <div class="label">15天内到期</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <div @click="toBusiness">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{data.businessCount}}</div>
                <div class="label">已过期</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="data-funnel" shadow="never">
      <div slot="header">
        <span>销售趋势</span>
      </div>
      <el-row>
        <el-col :span="24" align="right">
          <BusinessTrendChart
            :chartData="newBusinessTrendData"
          />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import FunnelChart from "@/views/crm/components/funnelHighcharts";
import {
  queryDashBoard,
  queryDynamicListByPage,
  queryBusinessTrend
} from "@/api/crm/dashBoard";
import { amountFormat } from "@/utils/index";
import BusinessTrendChart from "@/views/crm/dashboard/businessTrendChart";
import { treeselect } from "@/api/system/dept";
import { listUser } from "@/api/system/user";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState } from "vuex";

export default {
  name: "index",
  props: {},
  data() {
    return {
      amountFormat,
      typeOptions: [
        {
          dictValue: "0",
          dictLabel: "我的数据"
        },
        {
          dictValue: "1",
          dictLabel: "全部数据"
        }
      ],
      funnelData: [],
      newBusinessTrendData: {
        dataType: 1,
        data: []
      },
      winBusinessTrendData: {
        dataType: 2,
        data: []
      },
      data: {},
      followReplyList: [],
      systemNoticeList: [],
      dynamicTotal: 0,
      dynamicList: [],
      dynamicListVisible: false,
      dynamicListTitle: "",
      queryDynamicListParams: {
        pageNum: 1,
        pageSize: 10,
        dynamicType: null
      },
      dashBoardForm: {
        deptId: null,
        userId: null,
        year: new Date().getFullYear().toString(),
        dataType: 1 // 数据类型 1-新建商机 2-赢单商机
      },
      deptOptions: [],
      userOptions: [],
      businessTrendActiveName: "newBusiness",
      userSelectClearableFlag: true
    };
  },
  created() {
    this.queryDynamicList();
    this.getTreeselect();
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
      dept: state => state.user.dept
    })
  },
  components: {
    FunnelChart,
    BusinessTrendChart,
    Treeselect
  },
  watch: {},
  methods: {
    queryDynamicList() {
      // 动态类型 1-跟进回复 1-系统通知
      this.queryDynamicListParams.pageNum = 1;
      this.queryDynamicListParams.pageSize = 3;
      this.getDynamicListByType(1);
      this.getDynamicListByType(2);
    },
    queryDashBoardData() {
      queryDashBoard(this.dashBoardForm).then(response => {
        this.data = response.data;
        this.funnelData = this.getFunnelData(this.data.salesFunnelVos);
      });
      this.queryBusinessTrendByParam();
    },
    queryBusinessTrendByParam() {
      // 查询商机趋势
      queryBusinessTrend(this.dashBoardForm).then(response => {
        // dataType 数据类型 1-新建商机 2-赢单商机
        if (this.dashBoardForm.dataType === 1) {
          let newBusinessData = [];
          response.data.newBusinessTrendList.forEach(item => {
            newBusinessData.push(item.count);
          });
          this.newBusinessTrendData.data = newBusinessData;
        } else if (this.dashBoardForm.dataType === 2) {
          let winBusinessData = [];
          response.data.winBusinessTrendList.forEach(item => {
            winBusinessData.push(item.count);
          });
          this.winBusinessTrendData.data = winBusinessData;
        }
      });
    },
    businessTrendTabClick(tab) {
      if (tab.name === "newBusiness") {
        this.dashBoardForm.dataType = 1;
      } else if (tab.name === "winBusiness") {
        this.dashBoardForm.dataType = 2;
      }
      this.queryBusinessTrendByParam();
    },
    getDynamicListByType(dynamicType) {
      let queryParam = {
        pageNum: this.queryDynamicListParams.pageNum,
        pageSize: this.queryDynamicListParams.pageSize,
        dynamicType: dynamicType
      };
      queryDynamicListByPage(queryParam).then(response => {
        if (dynamicType === 1) {
          this.followReplyList = response.rows || [];
        } else if (dynamicType === 2) {
          this.systemNoticeList = response.rows || [];
        }
      });
    },
    /** 查询部门下拉树结构 */
    getTreeselect() {
      treeselect().then(response => {
        // 权限为本人时，会查不到数据，这里赋值本人部门
        if (!response.data || response.data.length === 0) {
          this.deptOptions = [
            { id: this.dept.deptId, label: this.dept.deptName }
          ];
          // 仅本人数据时，人员下拉框不能清除
          this.userSelectClearableFlag = false;
        } else {
          this.deptOptions = response.data;
        }
        // 进入页面时选择用户所在部门
        this.dashBoardForm.deptId = this.dept.deptId;
        // 进入页面时选择当前用户
        listUser({ deptId: this.dashBoardForm.deptId }).then(response2 => {
          this.userOptions = response2.rows;
          this.dashBoardForm.userId = this.currentUserId;
          this.queryDashBoardData();
        });
      });
    },
    deptSelect(node, instanceId) {
      this.userOptions = [];
      this.dashBoardForm.userId = null;
      listUser({ deptId: node.id }).then(response => {
        this.userOptions = response.rows;
      });
    },
    getFunnelData(originData) {
      let funnelData = [];
      originData.forEach(item => {
        funnelData.push({
          name: item.saleStageDesc,
          value: item.totalAmount
        });
      });
      return funnelData;
    },
    dateChange(year) {
      this.dashBoardForm.year = year;
      this.queryBusinessTrendByParam();
    },
    toCLue() {
      this.$router.push("/clue/manage");
    },
    toCustomer() {
      this.$router.push("/crm/customer/manage");
    },
    toContact() {
      this.$router.push("/crm/contact/manage");
    },
    toBusiness() {
      this.$router.push("/business/manage");
    },
    showMoreDynamicList(dynamicType) {
      this.queryDynamicListParams.pageNum = 1;
      this.queryDynamicListParams.pageSize = 10;
      this.queryDynamicListParams.dynamicType = dynamicType;
      if (dynamicType === 1) {
        this.dynamicListTitle = "跟进回复列表";
      } else if (dynamicType === 2) {
        this.dynamicListTitle = "系统通知列表";
      }
      this.getDynamicList();
      this.dynamicListVisible = true;
    },
    getDynamicList() {
      queryDynamicListByPage(this.queryDynamicListParams).then(response => {
        this.dynamicList = response.rows || [];
        this.dynamicTotal = response.total || 0;
      });
    },
    toDetail(item) {
      let url = "";
      // 回款计划
      if (item.targetType === "contractPlanFund") {
        url = "/crm/plan-fund/detail/" + item.targetId;
      } else if (item.targetType === "contractFundRecord") {
        // 回款记录
        url = "/crm/fund-record/detail/" + item.targetId;
      } else if (item.targetType === "contractInvoice") {
        // 发票
        url = "/crm/invoice/detail/" + item.targetId;
      } else {
        // 其他路径和targetType一样
        url = "/crm/" + item.targetType + "/detail/" + item.targetId;
      }
      this.$router.push(url);
    }
  }
};
</script>

<style lang='scss'>
.crm-dashboard {
  .data-simple {
    margin: 0 10px 10px 10px;
    border: 0;
    .data-card {
      cursor: pointer;
      margin: 2px 0;
      .data-block {
        height: 100px;
        text-align: center;
        .label {
          font-weight: 500;
          padding-top: 20px;
        }
        .value {
          font-weight: 400;
          padding-top: 30px;
        }
      }
    }
    .data-card:hover {
      color: #4480f3;
      border-color: #c7d9fb;
      background-color: #ecf2fe;
    }
  }
  .data-funnel {
    border: 0;
    margin: 10px;
  }

  .moreBtn {
    float: right;
    margin-top: -25px;
  }

  .dynamicList {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 13px;
  }

  .dynamicList2 {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 14px;
  }

  .cardLeftTopTitle {
    color: #9ea1a7;
    font-size: 14px;
  }

  .dynamicCard {
    min-height: 100px;
    height: 220px;
  }

  .noDataTip {
    margin-left: 45%;
    margin-top: 15px;
    color: #b7b5b5;
    font-size: 14px;
  }

  .dynamicContent {
    margin-top: 8px;
    width: 96%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .toDetailBtn {
    float: right;
    margin-top: -15px;
    padding: 0px;
  }

  .dynamicCreatTime {
    color: #969494;
  }

  .yearPicker {
    margin-top: -15px;
  }
}
</style>
